import React from "react";

const CalendarCellLoading = () => {
    const rows = [];
    let days = [];

    // Create 6 rows of 7 days (42 cells total)
    for (let week = 0; week < 6; week++) {
        for (let i = 0; i < 7; i++) {
            days.push(
                <div
                    key={`${week}-${i}`}
                    className="border p-1 h-28 bg-white animate-pulse overflow-hidden"
                >
                    <div className="space-y-1 my-2">
                        <div className="bg-gray-300 h-2 w-4/4 rounded"></div>
                        <div className="bg-gray-300 h-2 w-3/4 rounded"></div>
                        <div className="bg-gray-300 h-2 w-2/4 rounded"></div>
                        <div className="bg-gray-300 h-2 w-1/4 rounded"></div>
                    </div>
                </div>
            );
        }

        rows.push(
            <div className="grid grid-cols-7" key={`row-${week}`}>
                {days}
            </div>
        );
        days = [];
    }

    return <div>{rows}</div>;
};

export default CalendarCellLoading;
